module.exports = __webpack_public_path__ + "static/media/alberta_flag.00395f16.svg";